export interface Testimonial {
  id: string;
  name: string;
  avatarImage: string;
  role: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 'test-1',
    name: '漫画爱好者小琳',
    avatarImage: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20clean%20cream%20background%2C%20professional%20headshot%20quality%2C%20friendly%20approachable%20look&width=200&height=200&seq=avatar-test-1-m3k8&orientation=squarish',
    role: '资深读者 | 阅读时长 5年',
    content: '韩漫网站真的是我遇到过最好的漫画平台！画质超清晰，更新速度也很快，再也不用到处找资源了。最喜欢的就是分类功能，总能发现新的宝藏漫画。',
  },
  {
    id: 'test-2',
    name: '阿杰的漫画日记',
    avatarImage: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20confident%20expression%2C%20modern%20casual%20style%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%20quality%2C%20friendly%20look&width=200&height=200&seq=avatar-test-2-n5p2&orientation=squarish',
    role: '韩漫博主 | 推荐超过500部作品',
    content: '作为一个每天都要看漫画的人，这个网站的体验让我非常惊喜。界面简洁清爽，没有烦人的广告，阅读体验一流。强烈推荐给所有喜欢韩漫的朋友！',
  },
  {
    id: 'test-3',
    name: '夜雨声烦',
    avatarImage: 'https://readdy.ai/api/search-image?query=College%20student%20Asian%20female%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20soft%20diffused%20lighting%2C%20clean%20light%20background%2C%20professional%20headshot%20quality%2C%20kind%20expression&width=200&height=200&seq=avatar-test-3-q7w4&orientation=squarish',
    role: '大学生 | 闲暇时间都在看漫画',
    content: '从朋友那里知道的这个网站，一用就爱上了。漫画种类齐全，从恋爱到奇幻都有，而且每一部都有详细的分类和标签，找漫画特别方便。',
  },
];